import { useLocalSearchParams } from 'expo-router';
import { loginModuleQuery, useModule } from 'system/structure-modules';

export default function LoginIndexScreen() {
    const { LoginScreen } = useModule(loginModuleQuery);
    const { action } = useLocalSearchParams<'/[siloKey]/login/one', { action: string }>();
    return <LoginScreen action={action} />;
}
